<template>
    <v-select
        v-model="value"
        :options="question.settings.options"
        class="col-12 p-0"
        dir="rtl"
    >
        <template #open-indicator>
            <b class="button" />
        </template>

        <template #no-options>
            Select from the list
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';

export default {
    components: {
        vSelect
    },

    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            value: ''
        };
    },

    watch: {
        value(value) {
            this.$emit('input', value);
        }
    },

    created() {
        this.value = this.question.answer;
    }
};
</script>
